import { Col, Row } from "antd";
import { useDocumentContext } from "../../../context/DocumentContext/DocumentContext";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import { FileUploadConst } from "./constants";

const DocumentDetail = () => {
	const { setDocumentUpdate, documentDetail } = useDocumentContext();

	const handleFileChange = (files: FileData[] | null) => {
		setDocumentUpdate((prevState) =>
			prevState ? { ...prevState, document: files?.[0]?.file ?? null } : prevState);
	};

	return (
		<>
			<Row gutter={20}>
				<Col span={20}>
					<FileUploadComponent
						title={FileUploadConst.label}
						onChange={handleFileChange}
						maxFileSize={FileUploadConst.maxFileSize}
						allowedExtensions={FileUploadConst.extensions}
						defaultUrl={documentDetail?.url}
					/>
				</Col>
			</Row>
		</>
	);
};

export default DocumentDetail;
